import React from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";

import "./Dots.style.scss";

const Dots = ({ list, tooltip, value, dotHandler }) => {
  return (
    <div className="dots">
      <ReactTooltip />
      <span>LOW</span>
      <ul className="dots__items">
        {list.map((el, i) => (
          <li
            key={i}
            data-tip={tooltip[i]}
            className={
              value && value.length && value.toLowerCase() === el.toLowerCase()
                ? "dots__items-active"
                : ""
            }
            value={el}
            name="household_health"
            onClick={(e) => dotHandler(e)}
          ></li>
        ))}
      </ul>
      <span>High</span>
    </div>
  );
};

Dots.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
  tooltip: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
};

export default Dots;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/Dots/Dots.jsx